/**
 * CategoryFilter component for FAQs
 */
import React from "react";

interface CategoryFilterProps {
  categories: string[];
  selectedCategory: string | null;
  onSelectCategory: (category: string | null) => void;
}

const CategoryFilter: React.FC<CategoryFilterProps> = ({
  categories,
  selectedCategory,
  onSelectCategory,
}) => {
  const sortedCategories = [...categories].sort();
  const allCategories = ["All", ...sortedCategories];

  return (
    <div className="border-b border-gray-200 dark:border-gray-700/60">
      <ul className="text-sm font-medium flex flex-nowrap -mx-4 sm:-mx-6 lg:-mx-8 overflow-x-scroll no-scrollbar">
        {allCategories.map((category, index) => {
          const isAll = category === "All";
          const isSelected = isAll
            ? selectedCategory === null
            : category === selectedCategory;

          return (
            <li
              key={category}
              className="pb-3 mr-6 last:mr-0 first:pl-4 sm:first:pl-6 lg:first:pl-8 last:pr-4 sm:last:pr-6 lg:last:pr-8"
            >
              <button
                className={`whitespace-nowrap ${isSelected
                  ? "text-blue-500"
                  : "text-gray-500 dark:text-gray-400 hover:text-gray-600 dark:hover:text-gray-300"
                  }`}
                onClick={() => onSelectCategory(isAll ? null : category)}
              >
                {category}
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default CategoryFilter;
